<template>
  <div class="px-3 main-wrapper">
    <div class="d-flex justify-content-between align-items-center w-100 gap-2 my-4">
      <div class="flex-fill">
        <ProviderSelectDialog
          :providers="slotProviders"
          :selectedProvider="selectedProvider"
        />
      </div>
      <div class="flex-fill">
        <GameSearchDialog :games="games" />
      </div>
    </div>

    <div>
      <div
        class="error-box"
        v-if="error"
      >{{ error }}</div>
      <div>
        <!-- 🔹 Loading State -->
        <div
          v-if="isGamesLoading"
          class="game-list grid grid-cols-4"
        >
          <GameCardSkeleton
            v-for="n in 16"
            :key="n"
          />
        </div>

        <!-- 🔹 Empty State -->
        <div
          v-else-if="!games.length"
          class="flex flex-col items-center justify-center py-12 text-gray-400"
        >
          <van-empty description="No games available" />
        </div>

        <!-- 🔹 Game List -->
        <div
          v-else
          class="game-list grid grid-cols-4"
        >
          <GameCard
            v-for="(game, index) in newGames.length > 0 ? newGames : games"
            :key="index"
            @click="gameInit(game)"
            :game="game"
          />
        </div>
      </div>
    </div>

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br /><br />
              </span>
              <span>{{ limitText }}</span>
              <br /><br />
              <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import GameCard from "@/components/GameCard.vue";
import GameCardSkeleton from "@/components/GameCardSkeleton.vue";
import GameSearchDialog from "@/components/GameSearchDialog.vue";
import ProviderSelectDialog from "@/components/ProviderSelectDialog.vue";
import { Toast } from "vant";

export default {
  components: {
    GameCard,
    GameCardSkeleton,
    ProviderSelectDialog,
    GameSearchDialog
  },
  data() {
    return {
      games: [],
      isGamesLoading: false,
      error: null,

      name: null,
      newGames: [],
      limitText: "",
      desiredGame: null,

      selectedProvider: this.$route.query.provider || "",
    };
  },
  computed: {
    ...mapState('providers', [
      'slotProviders',
      'isProvidersFetching',
    ]),
  },
  methods: {
    ...mapActions(["fetchUser"]),
    ...mapActions('providers', ['fetchActiveProviders']),

    hideLimit() {
      $("#limit").modal("hide");
    },
    showAlertBox(game) {
      if (this.$route.query.provider === "PGSoft")
        this.limitText = "PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။";
      else if (this.$route.query.provider === "FaChai")
        this.limitText =
          "FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။";
      $("#limit").modal("show");
      this.desiredGame = game;
    },

    async fetchGames() {
      this.isGamesLoading = true;
      try {
        const { data } = await axios.get("/games", {
          params: {
            type: 'vs',
            provider: this.$route.query.provider,
          },
        });
        this.games = data;
      } catch (error) {
        console.error("Error fetching games:", error);
      } finally {
        this.isGamesLoading = false;
      }
    },

    async gameInit(game) {
      try {
        this.error = null;
        this.$store.commit("setLoading", true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        let providerID = this.$route.query.provider;
        const res = await axios.get("/games/url",
          {
            params: {
              gameID: game.gameID,
              provider: providerID,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        window.open(res.data.data.gameUrl, "_self");

      } catch (e) {
        const message =
          e?.response?.data?.message ||
          e?.response?.data ||
          "Something went wrong, please contact admin";

        this.error = message;
        Toast.fail("Failed");
      } finally {
        this.$store.commit("setLoading", false);
      }
    },
  },
  watch: {
    "$route.query.provider": {
      immediate: true,
      handler(newProvider) {
        this.selectedProvider = newProvider || "";
        this.$store.commit('setLoading', true);
        this.fetchGames();
        this.$store.commit('setLoading', false);
      },
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchActiveProviders();
    await this.fetchGames();
    this.$store.commit('setLoading', false);

  },
};
</script>

<style scoped></style>
